import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

type IssueRow = { row: number; message: string };

type Props = {
  errors?: IssueRow[];
  duplicates?: IssueRow[];
};

function IssueTable({
  title,
  rows,
  rowHeaderKey,
  rowHeaderDefault,
  msgHeaderKey,
  msgHeaderDefault,
}: {
  title: string;
  rows: IssueRow[];
  rowHeaderKey: string;
  rowHeaderDefault: string;
  msgHeaderKey: string;
  msgHeaderDefault: string;
}) {
  const { t } = useTranslation();
  return (
    <div className="mb-3">
      <h2 className="h6">{title}</h2>
      <Table striped bordered size="sm" responsive>
        <thead>
          <tr>
            <th>{t(rowHeaderKey, { defaultValue: rowHeaderDefault })}</th>
            <th>{t(msgHeaderKey, { defaultValue: msgHeaderDefault })}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={`${row.row}-${idx}`}>
              <td>{row.row}</td>
              <td>
                {row.message?.startsWith('api.error.') || row.message?.startsWith('excel_import.')
                  ? t(row.message, { defaultValue: row.message })
                  : row.message}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

/** 検証／インポート結果のエラー・重複表 */
export default function ExcelImportIssueTables({ errors = [], duplicates = [] }: Props) {
  const { t } = useTranslation();
  if (errors.length === 0 && duplicates.length === 0) return null;

  return (
    <>
      {errors.length > 0 ? (
        <IssueTable
          title={t('excel_import.error_list', { defaultValue: 'Errors' })}
          rows={errors}
          rowHeaderKey="excel_import.error_row"
          rowHeaderDefault="Row"
          msgHeaderKey="excel_import.error_message"
          msgHeaderDefault="Message"
        />
      ) : null}
      {duplicates.length > 0 ? (
        <IssueTable
          title={t('excel_import.duplicate_list', { defaultValue: 'Exact duplicates' })}
          rows={duplicates}
          rowHeaderKey="excel_import.duplicate_row"
          rowHeaderDefault="Row"
          msgHeaderKey="excel_import.duplicate_message"
          msgHeaderDefault="Details"
        />
      ) : null}
    </>
  );
}
